import { action, makeObservable, observable } from 'mobx';
import { IConfiguratorEntityStore } from './lookup/ILookup';
import { ICompositeProductApi } from '@canvas-logic/clp-sdk';
import { IComponentProductData } from '@canvas-logic/clp-domain';

export interface IComponentProductDataLookup extends IConfiguratorEntityStore {
  values: IComponentProductData[];
  current: IComponentProductData | null;
  componentKey: string;
}
export class ComponentProductDataLookup implements IComponentProductDataLookup {
  values: IComponentProductData[] = [];
  current: IComponentProductData | null = null;

  constructor(private readonly api: ICompositeProductApi, public readonly componentKey: string) {
    makeObservable(this, {
      updateValues: action.bound,
      updateCurrent: action.bound,
      values: observable,
      current: observable,
    });

    this.values = this.api.getComponentAllProducts(this.componentKey);
    this.updateCurrent();
  }

  async updateValues() {
    this.updateCurrent();
  }

  updateCurrent() {
    this.current = this.api.getComponentProductData(this.componentKey);
  }
}
